import { format } from "date-fns";
import clsx, { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function shortenName(name: string) {
  switch (name) {
    case "United Arab Emirates":
      return "UAE";
    case "United States":
      return "USA";
    default:
      return name;
  }
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getGateColour(cardinal: number) {
  const colour = CardinalColourMap[cardinal];
  if (!colour) return "#4f4f4f";
  return colour;
}

export function formatStartTime(startTime: string) {
  return format(new Date(startTime), "HH:mm");
}

export function formatSecondsToTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
}

export function getOrdinalSuffix(i: number) {
  let j = i % 10,
    k = i % 100;
  if (j === 1 && k !== 11) {
    return "st";
  }
  if (j === 2 && k !== 12) {
    return "nd";
  }
  if (j === 3 && k !== 13) {
    return "rd";
  }
  return "th";
}

export function getArrivalColor(arrival: number) {
  const colour = ArrivalColourMap[arrival];
  if (!colour) return "#ffffff";
  return colour;
}

export const ArrivalColourMap = {
  1: "#FFD602",
  2: "#C0C0C0",
  3: "#CD7F32",
};

export const CardinalColourMap = {
  1: "#ffffff",
  2: "#000000",
  3: "#EF4444",
  4: "#3C82F6",
  5: "#E9B404",
  6: "#22C55F",
  7: "#FF8400",
  8: "#8511DE",
  9: "#EB3CC4",
  10: "#00AE94"
};
